"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GTagPageviewObserver = /** @class */ (function () {
    function GTagPageviewObserver(conditions, action) {
        this.conditions = conditions;
        this.action = action;
    }
    GTagPageviewObserver.prototype.update = function (tracker, data) {
        if ((data.type === "event" && data.eventName === "page_view" && data.eventParams !== undefined)
            || (data.type === "config" && data.config !== undefined && (data.config.page_path !== undefined || data.config.page_location !== undefined || data.config.page_title !== undefined))) {
            var conditions = this.conditions;
            var eventParams = data.type === "event" ? data.eventParams : data.config;
            if ((conditions.pagePath === undefined || conditions.pagePath(eventParams.page_path))
                && (conditions.pageLocation === undefined || conditions.pageLocation(eventParams.page_location))
                && (conditions.pageTitle === undefined || conditions.pageTitle(eventParams.page_title))) {
                this.action(tracker, eventParams);
            }
        }
    };
    return GTagPageviewObserver;
}());
exports.default = GTagPageviewObserver;
